import React from 'react';
import { Link } from 'react-router-dom';
import useSeo from '../hooks/useSeo';
import './Pages.css';

function CloudBackupRecovery() {
  useSeo(
    'Cloud Backup & Recovery | Rev-Tech Services',
    'Protect business data with Rev-Tech cloud backup, disaster recovery planning, and secure restore capabilities.',
    {
      canonical: 'https://www.rev-technology.com/services/cloud-backup-recovery'
    }
  );

  return (
    <div className="page">
      <h1>Cloud Backup & Recovery</h1>
      <section className="content-section">
        <p>
          Protect your business data with cloud backup and disaster recovery planning from Rev-Tech. We ensure your critical
          files, systems, and applications are backed up securely and can be restored quickly if an outage or data loss event occurs.
        </p>
      </section>

      <section className="content-section">
        <h2>What&apos;s Included</h2>
        <ul className="values-list">
          <li><strong>Automated cloud backup:</strong> Regular backup of important data and system state.</li>
          <li><strong>Disaster recovery:</strong> Recovery planning and failover support to minimize downtime.</li>
          <li><strong>Secure storage:</strong> Encrypted backup storage in trusted cloud environments.</li>
          <li><strong>Recovery testing:</strong> Periodic verification to ensure backups are restorable.</li>
        </ul>
      </section>

      <section className="content-section">
        <h2>Why it matters</h2>
        <p>
          A reliable backup and recovery plan protects your business from hardware failure, ransomware, and natural disasters.
          Rev-Tech builds resilience so you can recover fast and keep operations moving.
        </p>
      </section>

      <Link to="/services" className="cta-button">Back to Services</Link>
    </div>
  );
}

export default CloudBackupRecovery;
